import { gql } from 'graphql-tag'

export default gql`
    query($internalName: String!, $locale: String!, $preview: Boolean) {
        sdrData: globalDataJsonCollection(
            limit: 1
            where: { internalName: $internalName }
            locale: $locale
            preview: $preview
        ) {
            items {
                data
            }
        }
    }

`
